import React, { useEffect, useState } from "react";
import PageHeader from "components/common/PageHeader";
import { Card, Col, Image, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  VerticalTimelineData,
  ZigzagTimelineData,
} from "data/timeline/timeline";
import classNames from "classnames";
import FalconComponentCard from "components/common/FalconComponentCard";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { PatientVisitsAPI } from "api";
import { FaPrescription } from "react-icons/fa";

const HistoryTimeline = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await PatientVisitsAPI.get({
          params: {
            patientId: location?.state?.id ?? Number.MAX_SAFE_INTEGER,
          },
        });
        const files = response?.data?.data ?? [];
        setData(files?.visits);
      } catch (error) {
        console.error("Failed to fetch lab tests:", error);
      }
    };

    fetchData();
  }, []);

  // console.log("data", data);

  return (
    <>
      {/* <PageHeader
        title="Timeline"
        // description="Create timeline description......"
        className="mb-3"
      /> */}
      {data?.length > 0 && (
        <Card className="mb-3 shadow-none">
          <Card.Body className="px-sm-4 px-md-8 px-lg-6 px-xxl-8">
            <div className="timeline-vertical">
              {data
                .sort((a, b) => new Date(b.visitDate) - new Date(a.visitDate))
                .map((item, index) => {
                  const {
                    diagnosis,
                    followupRequired,
                    nextVisitOn,
                    notes,
                    visitDate,
                  } = item;
                  return (
                    <div
                      key={index}
                      className={classNames("timeline-item", {
                        "timeline-item-start": index % 2 === 0,
                        "timeline-item-end": index % 2 !== 0,
                      })}
                    >
                      <div className="timeline-icon icon-item icon-item-lg text-primary border-300">
                        <FaPrescription size={20} />
                        {/* <FontAwesomeIcon icon={"book-open"} className="fs-8" /> */}
                      </div>
                      <Row
                        className={` ${
                          index % 2 == 0
                            ? "timeline-item-start"
                            : "timeline-item-end"
                        }`}
                      >
                        <Col lg={6} className="timeline-item-time">
                          <div>
                            <p className="fs-10 mb-0 fw-semibold">
                              {" "}
                              {new Date(visitDate).getFullYear()}{" "}
                            </p>
                            <p className="fs-11 text-600">
                              {" "}
                              {new Date(visitDate).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "long",
                              })}
                            </p>
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="timeline-item-content">
                            <div className="timeline-item-card">
                              <h5 className="mb-2">{diagnosis}</h5>
                              <p className="fs-10 mb-0">{notes}</p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  );
                })}
            </div>
          </Card.Body>
        </Card>
      )}

      {/* <Card>
        <FalconComponentCard.Header
          className="bg-body-tertiary"
          title="Timeline with media"
          noPreview
        />

        <Card.Body className="px-xxl-8 px-md-8 px-lg-6">
          <div className="timeline-zigzag">
            {ZigzagTimelineData.map((item, index) => {
              const { title, description, year } = item;
              const { img, width, height } = item.img;
              return (
                <Row
                  key={index}
                  className={classNames("timeline-item", {
                    "timeline-item-end": index % 2 === 0,
                    "timeline-item-start": index % 2 !== 0,
                  })}
                >
                  <Col lg={6} className="timeline-item-content">
                    <span className="bullet" />
                    <Row className="g-0 mt-n4">
                      <Col className="timeline-item-text">
                        <h3 className="text-primary mt-4 mt-sm-0">{year}</h3>
                        <h6 className="mt-2 mb-1 mt-sm-3">{title}</h6>
                        <p className="fs-10">{description}</p>
                      </Col>
                      <Col sm="auto">
                        <Image
                          src={img}
                          alt=""
                          rounded
                          className="timeline-item-media ms-3 ms-sm-0"
                          height={height || "188px"}
                          width={width || "250px"}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              );
            })}
          </div>
        </Card.Body>
      </Card> */}
    </>
  );
};

export default HistoryTimeline;
